import { useState, useCallback, useEffect } from "react";
import { IBank } from "src/domains";
import { queryGetBanks, queryGetBank } from "src/graphql";

export const useBanks = () => {
  const [items, setItems] = useState<IBank[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();
  let _isMount = true;

  const refresh = useCallback(async () => {
    if (!_isMount) {
      return;
    }
    if (_isMount) {
      setLoading(true);
    }
    try {
      const response = await queryGetBanks();
      if (_isMount) {
        setItems(response.data?.getBanks || []);
      }
    } catch (e) {
      console.error(e);
      if (_isMount) {
        setError(e as Error);
      }
    }
    if (_isMount) {
      setLoading(false);
    }
  }, [setItems]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    _isMount = true;
    return () => {
      _isMount = false;
    };
  }, []);

  return [items, loading, error, refresh] as const;
};

export const useBank = (id?: string) => {
  const [item, setItem] = useState<IBank | undefined>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();
  let _isMount = true;

  const refresh = useCallback(async () => {
    if (!_isMount || !id) {
      return;
    }
    if (_isMount) {
      setLoading(true);
    }
    try {
      const response = await queryGetBank({ id });
      if (_isMount) {
        setItem(response.data?.getBank);
      }
    } catch (e) {
      console.error(e);
      if (_isMount) {
        setError(e as Error);
      }
    }
    if (_isMount) {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    _isMount = true;
    return () => {
      _isMount = false;
    };
  }, []);

  return [item, loading, error, refresh] as const;
};
